import { render, staticRenderFns } from "./serviceprices.vue?vue&type=template&id=cabf929e&"
import script from "./serviceprices.vue?vue&type=script&lang=js&"
export * from "./serviceprices.vue?vue&type=script&lang=js&"
import style0 from "./serviceprices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports